module.exports = __webpack_public_path__ + "img/calc.b99cb676.png";